<template>
  <main v-if="garageData">
    <div class="garage-header-wrapper">
      <GarageBreadcrumbs :garage="garageData.garage" />
      <GarageAdsense v-if="!garageData.garage?.premium && !garageData.suggestedGarages?.length" />
      <div class="garage-map-and-gallery container">
        <GarageGallery
          :garageImages="garageData.garageImages"
          class="garage-map-and-gallery__gallery"
        />
        <div
          @click="toggleMapModal"
          class="garage-map-and-gallery__map"
        >
          <NuxtImg
            class="garage-map-and-gallery__map-img"
            src="/_nuxt/mapScreen.webp"
            alt="Mapa serwisu"
          />
          <NuxtImg
            class="garage-map-and-gallery__map-helper"
            src="/_nuxt/arrows.svg"
            alt="Pokaż mapę"
            height="40px"
            width="40px"
          />
          <NuxtImg
            class="garage-map-and-gallery__map-icon"
            src="/_nuxt/mapIcon.svg"
            alt="Lokalizacja warsztatu"
            height="48px"
            width="33px"
          />
        </div>

      </div>
      <div>
        <div class="garage-header-container container">
          <GarageHeader
            :garage="garageData.garage"
            :totalComments="totalCommentsComputed"
            :garageStats="garageData.garageStats"
            @go-to-tab="scrollToTab($event)"
          />
          <GarageWGZ
            v-if="garageData"
            :garage-tags="garageData.garageTags"
          />
        </div>
      </div>
    </div>

    <div
      v-if="garageData"
      class="garage-wrapper container"
    >
      <div class="garage-wrapper__main">
        <NuxtLink
          v-if="!!garageData.garage?.premium && garageData.garage?.onlineBooking"
          :to="route.path + (garageData.garageOtherServiceAvailability?.available ? '/services?other-reason=true' : '/services')"
          class="garage-wrapper__mobile-cta"
        >
          <DmButton
            has-icon="left"
            icon="i-calendar"
            title="Umów wizytę"
          />
        </NuxtLink>

        <GarageTabsController
          :tabs="tabs"
          v-model="currentTabKey"
          @update:modelValue="scrollToTab($event)"
        />

        <GarageVacationInfo
          v-if="garageData.garageVacationInfo?.vacation?.from"
          :garageVacationInfo="garageData.garageVacationInfo"
        />

        <GaragePriceList
          v-if="garagePriceListLength"
          :id="Tabs.Services"
          class="garage-wrapper__section"
          :premium="garageData.garage?.premium"
          :onlineBooking="!!garageData.garage?.onlineBooking"
          :garage="garageData.garage"
          :garage-price-list-with-categories="garageData.garagePriceListWithCategories"
          :mainContext="true"
          :limit="true"
          @show-service-details="showServiceDetails($event)"
        />

        <GarageCalendarRequest
          v-if="!garageData.garage?.premium"
          :id="Tabs.Services"
          class="garage-wrapper__section show-on-mobile"
          @show-calendar-request-modal="modals.calendarRequest = true"
        />
        <GarageSuggestedGarages
          v-if="!garageData.garage?.premium"
          :itemsToShow="1.2"
          :breakpoints="{ 768: { itemsToShow: 2, snapAlign: 'center' } }"
          :garage="garageData.garage"
          :suggestedGarages="garageData.suggestedGarages"
        />

        <GarageDetails
          :id="Tabs.Details"
          class="garage-wrapper__section"
          :garage="garageData.garage"
          :garageWorkTime="garageData.garageWorkTime"
          :totalComments="totalCommentsComputed"
          :garagePremium="!!garageData.garage?.premium"
          :suggestedGarages="garageData.suggestedGarages"
          :garageVirtualPhones="garageData.garageVirtualPhones"
          :garageVacationInfo="garageData.garageVacationInfo"
          @show-map="toggleMapModal"
        />
        <GarageOpinions
          :id="Tabs.Opinions"
          class="garage-wrapper__section"
          :garageComments="garageData.garageComments"
          :garageTotalComments="garageData.garageTotalComments"
          :garageTotalCommentsWithGoogleComments="totalCommentsComputed"
          :garageOtherComments="otherComments"
          :garage="garageData.garage"
          :commentsFromGoogle="garageData.commentsFromGoogle"
          :suggestedGarages="garageData.suggestedGarages"
          @load-more="loadMoreComments()"
        />
        <GarageReport
          v-if="!garageData.garage?.premium"
          :garage="garageData.garage"
        />

        <GarageMobileStickyButton
          v-if="!!garageData.garage?.premium"
          :garagePriceListCount="garageData.garagePriceListWithCategories?.length"
        />
      </div>

      <aside class="garage-wrapper__sidebar">
        <GarageSidebar
          :garageOtherServiceAvailability="garageData.garageOtherServiceAvailability"
          :garagePriceListCount="garageData.garagePriceListWithCategories?.length"
          :garage="garageData.garage"
          :garageWorkTime="garageData.garageWorkTime"
          :garagePremium="!!garageData.garage?.premium"
          :suggestedGarages="garageData.suggestedGarages"
          :garageVirtualPhones="garageData.garageVirtualPhones"
          :garageVacationInfo="garageData.garageVacationInfo"
          @show-calendar-request-modal="modals.calendarRequest = true"
        />
      </aside>
    </div>

    <div class="background-container">
      <div class="container">
        <GarageBrands
          v-if="garageData.garageBrands?.length"
          :id="Tabs.Brands"
          class="garage-wrapper__section"
          :garageBrands="garageData.garageBrands"
        />
        <GarageSupportedServices
          v-if="garageData.garageBrands?.length"
          :garageSupportedServices="garageData.garageSupportedServices"
        />
      </div>
    </div>

    <GarageHereMapsModal
      v-if="garageData?.garage && modals.map"
      :modals="modals"
      :garage="garageData.garage"
    />
    <GarageCalendarRequestModal
      :modals="modals"
      :suggestedGarages="garageData.suggestedGarages"
      :garage="garageData.garage"
    />
  </main>
  <DmLoader
    v-if="!!pending || !!store.loading"
    icon-size="icon-lg"
  />
  <GaragePriceCategoryElementModal
    :modals="modals"
    :service="selectedServiceForDetails"
  />
</template>

<script setup lang="ts">
// import components
const GaragePriceList = defineAsyncComponent(() => import('@/components/GaragePriceList.vue'));
const GarageHeader = defineAsyncComponent(() => import('@/components/GarageHeader.vue'));
const GarageTabsController = defineAsyncComponent(() => import('@/components/GarageTabsController.vue'));
const GarageDetails = defineAsyncComponent(() => import('@/components/GarageDetails.vue'));
const GarageOpinions = defineAsyncComponent(() => import('@/components/GarageOpinions.vue'));
const GarageBrands = defineAsyncComponent(() => import('@/components/GarageBrands.vue'));
const GarageGallery = defineAsyncComponent(() => import('@/components/GarageGallery.vue'));
const GarageSidebar = defineAsyncComponent(() => import('@/components/GarageSidebar.vue'));
const GarageHereMapsModal = defineAsyncComponent(() => import('@/components/GarageHereMapsModal.vue'));
const GarageSupportedServices = defineAsyncComponent(() => import('@/components/GarageSupportedServices.vue'));
const GarageWGZ = defineAsyncComponent(() => import('@/components/GarageWGZ.vue'));
const GarageMobileStickyButton = defineAsyncComponent(() => import('@/components/GarageMobileStickyButton.vue'));
const GarageBreadcrumbs = defineAsyncComponent(() => import('@/components/GarageBreadcrumbs.vue'));
const GarageCalendarRequest = defineAsyncComponent(() => import('@/components/GarageCalendarRequest.vue'));
const GarageCalendarRequestModal = defineAsyncComponent(() => import('@/components/GarageCalendarRequestModal.vue'));
const GarageSuggestedGarages = defineAsyncComponent(() => import('@/components/GarageSuggestedGarages.vue'));
const GarageReport = defineAsyncComponent(() => import('@/components/GarageReport.vue'));
const GaragePriceCategoryElementModal = defineAsyncComponent(() => import('@/components/GaragePriceCategoryElementModal.vue'));
//

import { ref, computed } from 'vue';
import { Tabs } from '@/models/enums';
import type { IDmComponentsItem } from '~/models/components';
import { DmLoader, DmButton } from '@dobrymechanik/vue-ui-v2';
import { apiRequests } from '@/api/api-instance';
import { appRequests } from '@/api/app-instance';
import type { GarageCommentJsonldGarageReadIdGarageReadNameCommentReadAnswerRead } from '~/api/docs/api';
import { useStore } from '~/store/store';
import { getCommentsTranslatePL } from '@/helpers/helpers';
import type { PriceElementView } from '~/api/docs/app';
import GarageVacationInfo from '~/components/GarageVacationInfo.vue';

const currentTabKey: Ref<Tabs> = ref(Tabs.Services);
const route = useRoute();
const modals = ref({
  map: false,
  calendarRequest: false,
  details: false
});
const selectedServiceForDetails: Ref<PriceElementView | null> = ref(null);
const garageStringId: Ref<string | undefined> = ref(undefined);
const otherComments: Ref<GarageCommentJsonldGarageReadIdGarageReadNameCommentReadAnswerRead[]> = ref([]);
const commentsPage: Ref<number> = ref(2);
const commentsBuffer: number = 5;
const rankingBuffer: number = 3;
const rankingRange: number = 5000;
const otherRepairsId: string = '9f1331f2-66c0-4341-ad06-cc6f074e1857';

// use
const nuxtApp = useNuxtApp();
const { $posthog } = useNuxtApp();
const store = useStore();

// computed
const tabs: ComputedRef<IDmComponentsItem<any, Tabs>[]> = computed(() => {
  return [
    {
      text: "Usługi", key: Tabs.Services, metadata: {
        counter: garagePriceListLength.value || null
      }
    },
    { text: "O warsztacie", key: Tabs.Details },
    {
      text: "Opinie", key: Tabs.Opinions, metadata: {
        counter: totalCommentsComputed.value || null
      }
    },
    { text: "Marki", key: Tabs.Brands }
  ]
    .filter(tab => {
      return !(tab.key === Tabs.Brands && !garageData.value?.garageBrands?.length);
    })
    .filter(tab => {
      return !(tab.key === Tabs.Services && (!garageData.value?.garage.onlineBooking || !garagePriceListLength.value));
    });
});

const garagePath = computed(() => {
  return route.params['garageId'] as string;
});

const totalCommentsComputed = computed(() => {
  return garageData.value?.garageTotalComments + garageData.value?.commentsFromGoogle.length;
});

const garagePriceListLength = computed(() => {
  return garageData.value?.garagePriceListWithCategories?.flatMap((category: any) => category.priceList).length || 0;
});

const canonicalUrl = computed(() => {
  return garageData.value?.garageSeo?.url || '';
});

// methods
const { data: garageData, pending, error, refresh } = await useAsyncData(
  "garageData",
  async () => {
    const { data: { id, slugHistory, slugCity, slug } } = await appRequests.getAppGarageIdByUrl(garagePath.value);
    const idString = id?.toString();

    if (!idString) return;
    const GETgarageSeo = appRequests.getAppGarageSeoSchema(idString);
    const GETgarage = apiRequests.apiGarageIdGet(idString);
    const GETgaragePriceListWithCategories = appRequests.getAppGaragePriceListWithCategories(idString, {
      seoServiceId: route.query['service-context'] || null
    });
    const GETgarageWorkTime = apiRequests.apiGarageGarageIdworkTimeGet(idString);
    const GETgarageComments = apiRequests.apiGarageGarageIdcommentsGetCollection(idString, { page: 1, itemsPerPage: commentsBuffer, state: 1 });
    const GETgarageBrands = apiRequests.apiGarageGarageIdbrandSpecializationGetCollection(idString);
    const GETgarageImageCollection = apiRequests.apiGarageGarageIdimagesGetCollection(idString, {
      'type[]': ['building-exterior-and-surroundings', 'example-cars', 'working-mechanics', 'workshop-hall']
    });
    const GETgarageSupportedServices = apiRequests.apiGarageGarageIdsupportedServicesGetCollection(idString);
    const GETgarageTagsCollection = apiRequests.apiGarageGarageIdtagsGetCollection(idString);
    const GETotherServiceAvailability = appRequests.getAppGarageAutobookingServiceAvailability(idString, otherRepairsId);
    const GETgarageCommentsStats = appRequests.getAppGarageCommentStatistics(idString);
    const GETgarageVirtualPhoneCollection = apiRequests.apiGarageGarageIdvirtualPhoneGetCollection(idString, { page: 1, active: true });
    const GEThelpers = appRequests.getAppGarageVirtualServiceCategoriesList(idString);
    const GETVacationInfo = apiRequests.apiGarageGarageIdvacationGet(idString);

    const [garageSeo, garage, garagePriceListWithCategories, garageWorkTime, garageComments, garageTotalComments, garageBrands, garageImages, garageSupportedServices, garageTags, garageOtherServiceAvailability, garageStats, garageVirtualPhones, garageVitualPriceList, garageVacationInfo] =
      await Promise.all([
        (await GETgarageSeo).data,
        (await GETgarage).data,
        (await GETgaragePriceListWithCategories).data,
        (await GETgarageWorkTime).data,
        (await GETgarageComments).data['hydra:member'],
        (await GETgarageComments).data['hydra:totalItems'],
        (await GETgarageBrands).data['hydra:member'],
        (await GETgarageImageCollection).data['hydra:member'],
        (await GETgarageSupportedServices).data['hydra:member'],
        (await GETgarageTagsCollection).data['hydra:member'],
        (await GETotherServiceAvailability).data,
        (await GETgarageCommentsStats).data,
        (await GETgarageVirtualPhoneCollection).data['hydra:member'],
        (await GEThelpers).data,
        (await GETVacationInfo).data
      ]);

    const GETgarageRanking = apiRequests.apiRankingGetCollection(
      { page: 1, itemsPerPage: rankingBuffer, geo_localization_range: `${garage.lat}_${garage.lng}_${rankingRange}`, "garage.premium[gt]": '0', context: 'max-gmv' }
    );
    const GETcommentFromGoogle = appRequests.getAppGarageGooglePlaceReview(idString);
    const [suggestedGarages, commentsFromGoogle] = await Promise.all([
      (await GETgarageRanking).data['hydra:member'],
      (await GETcommentFromGoogle).data
    ]);

    return {
      garageSeo, garage, garagePriceListWithCategories, garageWorkTime, garageComments, garageTotalComments, garageBrands, garageImages, garageSupportedServices, garageTags, garageOtherServiceAvailability, garageStats, garageVirtualPhones, suggestedGarages, commentsFromGoogle, slugHistory, slugCity, slug, garageVitualPriceList, garageVacationInfo
    };
  }, {
  lazy: true,
  getCachedData(key) {
    return nuxtApp.payload.data[key] || nuxtApp.static.data[key];
  }
});

if (!garageData.value && !nuxtApp.payload.data && !nuxtApp.payload.data) {
  throw createError({ statusCode: 404, message: 'Strona nie została odnaleziona', fatal: true });
}

if (!!garageData.value?.slugHistory) {
  if (useRoute().params['garageId'] !== `${garageData.value.slug}.html`) {
    await navigateTo(`/mechanicy/${garageData.value.slugCity}/${garageData.value.slug}.html`, { redirectCode: 301 });
  }
}

if (!!garageData.value) {
  if (garageData.value.garage.state !== 1) {
    throw createError({ statusCode: 404, message: 'Strona nie została odnaleziona', fatal: true });
  }
}

// SEO
useJsonld(() => (garageData.value?.garageSeo || {}));

const parseId = async (): Promise<number | undefined> => {
  try {
    const { data: { id } } = await appRequests.getAppGarageIdByUrl(garagePath.value);
    return id;
  } catch {
    // catch error
  }
};

const loadMoreComments = async () => {
  if (!garageStringId.value) {
    const garageId = await parseId();
    garageStringId.value = garageId?.toString();
  }
  if (!garageStringId.value) return;

  try {
    store.setLoader();
    const { data } = await apiRequests.apiGarageGarageIdcommentsGetCollection(garageStringId.value,
      {
        page: commentsPage.value,
        itemsPerPage: commentsBuffer,
        state: 1
      }
    );

    // append comments
    otherComments.value.push(...data['hydra:member']);

  } catch (e) {
    // catch error
  } finally {
    store.unsetLoader();
    // compute next page
    commentsPage.value += 1;
  }

};

const showServiceDetails = (service: PriceElementView | null) => {
  selectedServiceForDetails.value = service;
  modals.value.details = !!service;
};

const toggleMapModal = () => {
  modals.value.map = !modals.value.map;
};

const scrollToTab = (tab: Tabs) => {
  const element = document.getElementById(tab) as HTMLElement;
  const tabsController = document.getElementById('tabs-controller') as HTMLElement;

  const top = element?.getBoundingClientRect().top + window.pageYOffset - tabsController.getBoundingClientRect().height;

  window.scrollTo({
    top: top,
    behavior: 'smooth'
  });
};

onMounted(async () => {
  setTimeout(() => {
    // POSTHOG
    $posthog()?.capture('$pageview', {
      garageType: !!garageData.value?.garage.premium ? 'premium' : 'free',
      garageId: garageData.value?.garage.id || null
    });

  }, 0);
});


// computed
const metaTitle = computed(() => {
  return !!garageData.value
    ? garageData.value.garage.premium && garageData.value.garage.onlineBooking
      ? `${garageData.value.garage.name} • Umów wizytę online`
      : `${garageData.value.garage.name} • ${garageData.value.garage.city}, ${garageData.value.garage.address} • Sprawdź opinie`
    : 'Znajdź mechanika • Umów wizytę w warsztacie • DobryMechanik.pl';
});
const metaDescription = computed(() => {
  return !!garageData.value
    ? garageData.value.garage.premium && garageData.value.garage.onlineBooking
      ? `Sprawdź ${totalCommentsComputed.value} ${getCommentsTranslatePL(totalCommentsComputed.value)} o warsztacie: ${garageData.value.garage.name} z miasta: ${garageData.value.garage.city}, ${garageData.value.garage.address}. Umów wizytę online u mechanika samochodowego.`
      : `Sprawdź ${totalCommentsComputed.value} ${getCommentsTranslatePL(totalCommentsComputed.value)} o warsztacie: ${garageData.value.garage.name} z miasta: ${garageData.value.garage.city}, ${garageData.value.garage.address}.`
    : '';
});

useSeoMeta({
  title: () => metaTitle.value,
  description: () => metaDescription.value,
  ogTitle: () => metaTitle.value,
  ogDescription: () => metaDescription.value,
  robots: () => 'index, follow',
  ogImageSecureUrl: () => garageData.value ? `https://dobrymechanik.pl/img/mechanics/${garageData.value.garage.id}-normal.jpg` : '',
  ogType: () => 'article',
  ogSiteName: () => 'dobrymechanik.pl',
  ogUrl: () => 'https://dobrymechanik.pl' + route.fullPath,
});

// use 
useHead({
  meta: [
    {
      property: 'fb:page_id',
      content: '278611051076'
    },
    {
      property: 'business:contact_data:street_address',
      content: garageData.value?.garage.address || ''
    },
    {
      property: 'business:contact_data:locality',
      content: garageData.value?.garage.city || ''
    },
    {
      property: 'business:contact_data:postal_code',
      content: garageData.value?.garage.postalCode || ''
    },
    {
      property: 'business:contact_data:country_name',
      content: 'Polska'
    },
    {
      name: 'verify-v1',
      content: 'vq44RBVSLNGVzt/MUCQGn/J6DsCbta0LOGJerCieh74='
    },
    {
      name: 'google-site-verification',
      content: 'uoexwv3GK98JOFIWb9X2SRDqJxpJFJBHMF-DhH2XS5I'
    }
  ],
  link: [
    { rel: 'canonical', href: () => canonicalUrl.value },
    { rel: 'dns-prefetch', href: 'https://ajax.googleapis.com' },
    { rel: 'dns-prefetch', href: 'https://googletagservices.com' },
    { rel: 'dns-prefetch', href: 'https://partner.googleadservices.com' }
  ],
  script: [
  ]
});
</script>

<style lang="scss" scoped>
@import url('assets/styles/pages/garage.scss');
</style>